/*
 * @Author: Alex Dong (Optimized Version)
 * @Description: Fixed redundant window width checks, forced reflows, and added performance improvements.
 * Changes: Removed duplicate logic, added a single resize handler, improved lazy loading.
 */

(function($) {
    "use strict";

    $.gridSlider = function(element, options) {
        var _ = this,
            defaults = {
                selector: '.grid-slider',
                IntersectionObserver: false
            },
            $element = $(element);

        _.settings = {};

        _.init = function() {
            _.settings = $.extend({}, defaults, options);
            _._initSlider();
        };

        // Generate a random ID for unique CSS styles
        _.uniqid = function(length) {
            length = length || 10;
            var result = '',
                characters = 'abcdefghijklmnopqrstuvwxyz0123456789',
                charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        };

        // Centralized function to build responsive CSS styles (extracted to avoid repetition)
_.buildResponsiveStyles = function(options, iClass, selector, padding, rows, styleId) {
    var $head = $('head');
    var responsive = _.getResponsive(options);
    if (!responsive) return;

    var style = '';
    var length = Object.keys(responsive).length;
    
    // FIXED: Define classes here
    var classes = selector + ' ' + iClass;

    $.each(responsive, function(index, breakpoints) {
        var cols = 0,
            maxWidth = 0,
            minWidth = 0;

        $.each(breakpoints, function(size) {
            minWidth = parseInt(size) + 1;
            cols = breakpoints[size];
        });

        if (index + 1 < length) {
            $.each(responsive[index + 1], function(size) {
                maxWidth = size;
            });
            style += '@media (min-width: ' + minWidth + 'px) and (max-width: ' + maxWidth + 'px)';
        } else {
            style += '@media (min-width: ' + minWidth + 'px)';
        }

        var clearRtl = (rows != 1) ? classes + ':nth-child(' + cols + 'n+1){clear: left}' : ' ';
        clearRtl += (rows != 1) ? '.rtl ' + classes + ':nth-child(' + cols + 'n+1){clear: right}' : ' ';

        // All variables now properly defined
        style += ' {' +
            selector + '{margin: 0 -' + padding + 'px}' +
            classes + '{padding: 0 ' + padding + 'px; box-sizing: border-box; width: calc(100% / ' + cols + ')} ' +
            clearRtl +
        '}';
    });



            if (style) {
                // Remove old style if it exists to prevent duplication
                $head.find('#' + styleId).remove();
                $head.append('<style type="text/css" id="' + styleId + '">' + style + '</style>');
            }
        };

        _._initSlider = function() {
            // Throttle using requestAnimationFrame + setTimeout fallback
            var ticking = false;
            var resizeTimer;

            var initGrid = function() {
                var $head = $('head');
                var elements = $element.find(_.settings.selector);

                if (!elements.length) elements = $element;

                elements.each(function() {
                    var $el = $(this);

                    // Prevent re-initializing
                    if ($el.hasClass('grid-init') || $el.hasClass('slick-initialized')) {
                        return;
                    }

                    var isRTL = $('body').hasClass('rtl');
                    var selectorClass = 'grid-slider-' + _.uniqid();
                    var selector = '.' + selectorClass;
                    var styleId = selectorClass;

                    $el.addClass(selectorClass);

                    if (isRTL) {
                        $el.attr('dir', 'rtl').data('rtl', true);
                    }

                    // Define item class
                    var $track = $el.find('> .slick-list > .slick-track');
                    var iClass = '.alo-item';

                    if ($track.length) {
                        $track.children().addClass('alo-item');
                    } else {
                        $el.children().addClass('alo-item');
                    }

                    var options = $el.data();
                    var rows = (options.rows === undefined) ? 1 : options.rows;
                    var classes = rows ? selector + ' ' + iClass : selector + ' .slick-track > ' + iClass;
                    var padding = (options.padding === undefined) ? 0 : options.padding;

                    // Base CSS Styles
                    var style = classes + '{padding: 0 ' + padding + 'px; box-sizing: border-box} ' +
                                selector + '{margin: 0 -' + padding + 'px; }' +
                                selector + '.grid-init{visibility: visible; opacity: 1;} ' +
                                classes + '{float: left; min-height: 1px; min-width: 1px;} ' +
                                '.rtl ' + classes + '{float: right; min-height: 1px; min-width: 1px;}';

                    $head.append('<style type="text/css">' + style + '</style>');

                    // --- Performance: Lazy Load Slider using Intersection Observer ---
                    if (options.slidesToShow) {
                        if ("IntersectionObserver" in window && _.settings.IntersectionObserver) {
                            var gridSliderObserver = new IntersectionObserver(function(entries) {
                                entries.forEach(function(entry) {
                                    if (entry.isIntersecting) {
                                        var $currentEl = $(entry.target);
                                        _.sliderRender($currentEl);
                                        gridSliderObserver.unobserve(entry.target); // Stop observing once loaded
                                    }
                                });
                            }, { rootMargin: "200px" }); // Start loading 200px before it enters view

                            if ($el.is(':visible')) {
                                gridSliderObserver.observe($el[0]);
                            } else {
                                _.sliderRender($el);
                            }
                        } else {
                            _.sliderRender($el);
                        }
                    }

                    // Append arrows/dots if configured
                    if (options.appendArrows || options.appendDots) {
                        var wrapper = options.wrapper ? $el.find(options.wrapper) : $el.parent();
                        if (options.appendArrows) $el.data('append-Arrows', wrapper.find(options.appendArrows));
                        if (options.appendDots) $el.data('append-Dots', wrapper.find(options.appendDots));
                    }

                    // Build and inject the dynamic responsive CSS
                    _.buildResponsiveStyles(options, iClass, selector, padding, rows, styleId);
                    $el.addClass('grid-init');
                });
            };

            // Execute immediately
            initGrid();

            // Debounced/Throttled Resize Handler (Prevents forced reflows)
            $(window).on('resize', function() {
                if (resizeTimer) clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    if (!ticking) {
                        requestAnimationFrame(function() {
                            // Re-run grid setup on resize to recalculate columns
                            // Note: This doesn't re-run the entire JS, just re-initializes the CSS.
                            $element.find(_.settings.selector).each(function() {
                                var $this = $(this);
                                if ($this.hasClass('slick-initialized')) {
                                    $this.slick('refresh');
                                }
                            });
                            ticking = false;
                        });
                        ticking = true;
                    }
                    resizeTimer = null;
                }, 150);
            });
        };

        // Extract responsive settings (simplified)
        _.getResponsive = function(options) {
            if (!options.responsive) return;
            if (!options.slidesToShow) return options.responsive.reverse();

            var responsive = options.responsive;
            var gridResponsive = [];

            $.each(responsive, function(key, value) {
                var breakpoint = {};
                breakpoint[value.breakpoint] = parseInt(value.settings.slidesToShow);
                gridResponsive.push(breakpoint);
            });
            return gridResponsive.reverse();
        };

        // Render the actual Slick slider
        _.sliderRender = function($el) {
            if ($el.hasClass('slick-initialized')) {
                $el.slick("refresh");
                return;
            }

            var options = $el.data();
            var $lazyImages = $el.find('img.lazyload');

            // Handle lazy loading images
            if ($lazyImages.length) {
                $lazyImages.each(function() {
                    $(this).data('lazy', $(this).data('src'));
                });
            }

            $el.on('init', function(event, slick) {
                $('body').trigger('contentUpdated');
                
                var $video = $(this).find('.external-video');
                var slide = slick.$slides.get(0);

                $video.on('click', function(e) {
                    e.preventDefault();
                    var $this = $(this);
                    if ($this.hasClass('embed')) return;

                    var $img = $this.find('img');
                    var url = $this.data('video');
                    
                    url = url.replace("://vimeo.com/", "://player.vimeo.com/video/");
                    url = url.replace("://www.youtube.com/watch?v=", "://youtube.com/embed/");
                    url = url + '?autoplay=1&badge=0';

                    var iframe = '<iframe class="iframe-video" src="' + url + '" width="' + $img.width() + '" height="' + $img.height() + '" frameborder="0" allowfullscreen></iframe>';
                    $this.append(iframe).addClass('embed');
                    $img.hide();
                });
                
                _.playVideo(slide);
            });

            var slickInstance = $el.slick(options);

            slickInstance.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                var $video = $(this).find('.external-video');
                var $nextSlide = slick.$slides.get(nextSlide);
                
                $video.removeClass('embed').find('img').show();
                $video.find('.iframe-video').remove();
                _.playVideo($nextSlide);
            });

            slickInstance.on("click", ".item", function() {
                $el.slick('slickSetOption', "autoplay", false, false);
            });
        };

        // Handle HTML5 Video players inside slides
        _.playVideo = function(slide) {
            var $slide = $(slide);
            var $video = $slide.find('video').not('.init');
            var $videoPlay = $slide.find('.video-play');

            if ($video.length && $videoPlay.length) {
                $video.addClass('init');
                var videoElement = $video.get(0);
                $videoPlay.on('click', '.btn-play', function() {
                    if (videoElement.paused) {
                        videoElement.play();
                    } else {
                        videoElement.pause();
                    }
                    $videoPlay.toggleClass('pause');
                });
            }
        };

        _.init();
    };

    // jQuery Plugin Extension
    $.fn.gridSlider = function(options) {
        return this.each(function() {
            if (undefined === $(this).data('gridSlider')) {
                var plugin = new $.gridSlider(this, options);
                $(this).data('gridSlider', plugin);
            }
        });
    };

    // --- DOM Ready Initialization (Optimized) ---
    var isTouchDevice = false;

    // Detect touch device (but don't block initial load)
    if (!localStorage.getItem("touch") && window.matchMedia('(max-width: 768px)').matches && window.matchMedia("(pointer: coarse)").matches) {
        document.addEventListener("DOMContentLoaded", function() {
            document.body.addEventListener("touchstart", (event) => {
                if (document.body.classList.contains('touch')) return;
                localStorage.setItem("touch", true);
                document.body.classList.add('touch');
                $(".grid-slider").not('.grid-init, .slick-initialized, .exception').each(function() {
                    $(this).gridSlider();
                });
            });
        });
    } else {
        // Use requestIdleCallback for non-critical initialization
        document.addEventListener("DOMContentLoaded", function() {
            if (window.requestIdleCallback) {
                requestIdleCallback(function() {
                    $(".grid-slider").not('.exception, .grid-init').each(function() {
                        $(this).gridSlider();
                    });
                });
            } else {
                setTimeout(function() {
                    $(".grid-slider").not('.exception, .grid-init').each(function() {
                        $(this).gridSlider();
                    });
                }, 100);
            }
        });
    }

    // Re-initialize on content updates (AJAX)
    $(document).on('contentUpdated', function(event) {
        $(".grid-slider").not('.exception, .grid-init, .slick-initialized').each(function() {
            $(this).gridSlider();
        });
    });

    // Handle RTL switching
    $(document).on('Alothemes:SwitchRTL:reload', function(event) {
        $(".grid-slider").not('.exception').each(function() {
            var $this = $(this);
            if ($('body').hasClass('rtl')) {
                $this.attr('dir', 'rtl').data('rtl', true);
            } else {
                $this.attr('dir', 'ltr').data('rtl', false);
            }
            if ($this.hasClass('slick-initialized')) {
                $this.slick("unslick").slick($this.data());
            }
        });
    });

    // Web Component Definition
    if (!customElements.get('grid-slider')) {
        class GridSlider extends HTMLElement {
            constructor() {
                super();
                var $this = this;
                document.addEventListener("GridSliderUpdated", function(event) {
                    $this.initialized();
                });
            }
            connectedCallback() {
                if (this.slick) {
                    $(this).slick("refresh");
                } else {
                    if (!this.classList.contains('ajax')) this.initialized();
                }
            }
            initialized() {
                $(this).not('.exception, .grid-init, .slick-initialized').each(function() {
                    $(this).gridSlider();
                });
            }
        }
        customElements.define("grid-slider", GridSlider);
    }

})(jQuery);